"use strict";

var PromptList = require("app/shared/components/Prompt/prompt-list");

var AccountRemovalPrompt = React.createClass({
  checkboxItems: function(){
    return [
      {checked: false, text: "Todos os usuários perderão acesso à conta"},
      {checked: false, text: "Todos os negócios e contatos cadastrados no Agendor serão apagados"},
      {checked: false, text: "Todos os comentários e tarefas cadastrados no Agendor serão apagados"},
      {checked: false, text: "Entendo que este é um processo irreversível"},
    ]
  },

  render: function() {
    var props = {
      title:"Quer mesmo excluir esta conta?",
      text: "Ao confirmar esta ação sua conta será excluída e todos os dados serão apagados. Por favor, confirme sua ciência que:",
      hideWarningIcon:false,
      buttonText:"confirmar",
      buttonClasses:"btn btn-danger",
      autoClose: true,
      isOpen: true,
      onClose: this.props.onClose,
      checkboxItems: this.checkboxItems(),
      onConfirm: () => {
        window.location.href='/src/php/sistema/http/obj/Cliente/desativar.php';
      },
      type: "confirm"
    };

    return <PromptList {...props} ></PromptList>
  }
});

module.exports = AccountRemovalPrompt;



// WEBPACK FOOTER //
// ./app/screens/Account/components/account-removal-prompt.jsx